<template>
	<div id="addressBar" class="col4 field anAddressField">

		<div>

			<!-- This field is a tool and cannot be required -->
			<!-- The other fields (street1, city…) can be required -->
			<label for="address">{{ $t('inputsTexts.googleAPI.label') }}</label>

			<div class="addressInput">

				<div>
					<input 
					name="address"
					type="text"
					v-model.lazy:modelValue="userAddressInput"
					@input="userInputSomething"
					:placeholder="$t('inputsTexts.googleAPI.placeholder')"
					>
					<div class="relative">
						<div v-show="returnedPredictions.length > 0" id="addresslist" class="address-list" :class="{addressBorder: addAClass}">
							<ul>
								<li 
								v-for="(item, index) in returnedPredictions" 
								tabindex="0" 
								@click="selectAddress(item.placeId)" 
								:key="index" 
								@keyup.prevent.enter="selectAddress(item.placeId)"
								@keyup.prevent.space="selectAddress(item.placeId)"
								>{{item.address}}</li>
							</ul>
						</div>
					</div>
				</div>


				<div id="clearAddressBtn" @click="clearFilter">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50" overflow="visible" stroke="black" stroke-width="5" stroke-linecap="round">
						<line x1="10" y1="10" x2="40" y2="40" />
						<line x1="40" y1="10" x2="10" y2="40" />
					</svg>
				</div>

			</div>
		</div>

		<div class="helper" role="textbox" :aria-label="'More info for addressBar field'">&nbsp;</div>

	</div>
</template>

<!-- ================================================================================== -->

<script>
	import customLog from "../mixins/CustomLog";
	import APICalls from "../mixins/APICalls";

	export default {
		name:"AddressBar",
		mixins: [
			customLog,
			APICalls,
		],

		data() {
			return {
				returnedPredictions: [],
				choosenAddressIs: null,
				userAddressInput: null,
				addAClass: false,
			};
		},

		methods: {

			clearFilter(){
				/* Send the clean signal to the parent of this component */
				this.log("Clean address-related fields", 'low');
				this.userAddressInput = null;
				this.$emit('reset');
			},

			async selectAddress(placeId){
				this.log(`selectAddress`, 'low');

				let choosenAddress = this.returnedPredictions.find(elem => elem.placeId === placeId);
				this.userAddressInput = choosenAddress.address;

				/* Close list by emptying the list */
				this.returnedPredictions.length = 0;
				this.log("List should close", 'wip');

				let details = await this.askForPlaceIdDetails(choosenAddress.placeId);
				this.sendResultToForm(this.formatDetailsForFormUse(details.values.result));
			},

			formatDetailsForFormUse(data){
				this.log(`formatDetailsForFormUse`, 'function');			
				// this.log(data.address_components); // this one is an array. I should use "find" again. Detail below.

				let housenumber = data.address_components.find(comp => comp.types.includes('street_number'));
				let street1 = data.address_components.find(comp => comp.types.includes('route'));
				let country = data.address_components.find(comp => comp.types.includes('country'));
				let postalcode = data.address_components.find(comp => comp.types.includes('postal_code'));
				let city = data.address_components.find(comp => comp.types.includes('locality'));

				let finalAddress = {
					placeId: data.placeId,
					formattedAddress: data.formatted_address,
					// I could add "geometry" (long. & lat.), "url" (to see on google map), if requested one day.
					fields: {
						street1 : street1?.long_name,
						city: city?.long_name,
						postalcode: postalcode?.long_name,
						housenumber: housenumber?.long_name,
						country: country?.long_name,
						countrycode: country?.short_name
					}
				};

				return finalAddress;
			},

			sendResultToForm(data){
				this.log(`sendResultToForm`, 'wip');
				this.$emit('selectedAddress', data);
			},

			userInputSomething(event){
				let str = event.target.value;
				// If long enought, we contact our API
				if (str.length > 6){
					this.askApiForPredictions(str);
					this.addAClass = true;
				}else{
					this.log(`String too short to start a search`, 'low');
					this.addAClass = false;
				}
			},

			async askApiForPredictions(input){
				let dataFromApiPrediction = await this.sendStringForPredictions(input);
				this.log(`What is returned by the API`, 'wip');
				this.returnedPredictions = dataFromApiPrediction.values;
			},


			askForPlaceIdDetails(placeId){
				let data = {placeId : placeId};
				let url = "entry-assist/details"; // obtain details from "placeId"

				return new Promise((resolve, reject) => {
					this.axios.post(url, data)
					.then(res => {
						this.log(`Success in posting data`,'success');
						this.log(res);	
						resolve(res.data);
					})
					.catch(error => {
						this.log(`Failed attempt to post data`, 'alert');
						this.log(error);
						// TODO in case of 401, display "votre session a expiré, veuillez recharger et recommencer." ?
						reject(error);
					})
				});

			},

			sendStringForPredictions(str){

				// get current lang
				let lang = this.$store.getters.getLang;

				let data = {
					// mandatory
					"address": str,
					// optionnal
					'lang': lang, // for result translation 
					'country': ['be', 'nl', 'lu', 'fr'], // to limit to a certain regions 
					// ! 'de' is not a valid says Action-API.
				};

				let url = "entry-assist/address"; // obtain predictions

				return new Promise((resolve, reject) => {
					this.axios.post(url, data)
					.then(res => {
						this.log(`Success in posting data`,'success');
						this.log(res);	
						resolve(res.data);
					})
					.catch(error => {
						this.log(`Failed attempt to post data`, 'alert');
						this.log(error);
						reject(error);
					})
				});
			},

			postAddressToGoogleApiForPredictionsPassed(){
				this.log("ok", 'green');
			},

			postAddressToGoogleApiForPredictionsFailed(){
				this.log("not ok", 'red');
			},


		},

	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>

</style>
